/* eslint-disable require-jsdoc */
export class DemographicInsights {
    constructor() {
        this.customer = "";
        this.typicalAge = "";
        this.attitudes = "";
        this.hopesAndDreams = "";
        this.victoriesAndFailures = "";
        this.failures = "";
        this.outsideForces = "";
        this.prejudices = "";
        this.coreBeliefs = "";
    }
}
